import React from 'react';
import { Users, BadgePercent, QrCode, LineChart } from 'lucide-react';
import { useMarketplaceStats } from './JoinStrip';

const POINTS = [
  [Users, 'Customers who want to buy', 'AGA members browse the Marketplace looking for where to spend — and choose partners with a member discount.'],
  [BadgePercent, 'You set the discount', 'One simple offer: a Pro % and a bigger Elite %. Change it anytime.'],
  [QrCode, 'Discount only when they pay', 'No coupons to print. Scan the member QR, enter the bill — the right discount is applied.'],
  [LineChart, 'See the results', 'Track visits, sales and new customers AGA brought you from your dashboard.'],
];

/** Value proposition for prospective merchants (merchant apply page). */
export function MerchantPitch() {
  const stats = useMarketplaceStats();
  return (
    <div className="rounded-2xl border border-[#00E676]/25 bg-[#041A3B] p-5 sm:p-6" data-testid="merchant-pitch">
      {stats && (
        <p className="text-sm text-[#A0B4CC] mb-4" data-testid="merchant-pitch-reach">
          Reach <b className="text-white">{stats.members.toLocaleString()}</b> active AGA members alongside <b className="text-white">{stats.merchants.toLocaleString()}</b> partner merchants.
        </p>
      )}
      <div className="grid sm:grid-cols-2 gap-4">
        {POINTS.map(([Icon, title, body]) => (
          <div key={title} className="flex gap-3">
            <div className="w-9 h-9 rounded-lg bg-[#00E676]/10 flex items-center justify-center flex-shrink-0"><Icon className="w-4 h-4 text-[#00E676]" /></div>
            <div>
              <p className="text-white text-sm font-semibold">{title}</p>
              <p className="text-xs text-[#A0B4CC] mt-0.5">{body}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
